"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
exports.StyledTypography = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: \"SFPro\";\n  /* font-family: SF Pro Display, SF Pro Icons, AOS Icons, Helvetica Neue,\n    Helvetica, Arial, sans-serif; */\n\n  ", "\n\n  @media (max-width: 600px) {\n    /* width: 100%; */\n\n    ", "\n  }\n"], ["\n  font-family: \"SFPro\";\n  /* font-family: SF Pro Display, SF Pro Icons, AOS Icons, Helvetica Neue,\n    Helvetica, Arial, sans-serif; */\n\n  ", "\n\n  @media (max-width: 600px) {\n    /* width: 100%; */\n\n    ", "\n  }\n"])), function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case "title1":
            return "\n          font-size: 80px;\n          font-weight: ".concat(theme_1.default.fontWeights.bolder, ";\n          margin: 0 0 24px 0;\n          max-width: 760px;\n          line-height: 1;\n          letter-spacing: -0.015em;\n        ");
        case "title2":
            return "\n          font-size: 48px;\n          font-weight: ".concat(theme_1.default.fontWeights.bold, ";\n          margin: 0 0 24px 0;\n          max-width: 760px;\n          line-height: 1;\n          letter-spacing: -.003em;\n        ");
        case "title3":
            return "\n          font-size: 24px;\n          font-weight: ".concat(theme_1.default.fontWeights.bold, ";\n          margin: 0 0 16px 0;\n          max-width: 380px;\n          line-height: 1.1;\n          letter-spacing: 0em;\n        ");
        case "title4":
            return "\n          font-size: 18px;\n          font-weight: ".concat(theme_1.default.fontWeights.bold, ";\n          margin: 0 0 8px 0;\n          max-width: 380px;\n          line-height: 1.1;\n          letter-spacing: 0em;\n        ");
        case "subtitle1":
            return "\n          color: ".concat(theme_1.default.colorsPalette.gray.light, ";\n          font-weight: ").concat(theme_1.default.fontWeights.bold, ";\n          font-size: ").concat(theme_1.default.fontSizes.small, ";\n          letter-spacing: 1px;\n          text-transform: uppercase;\n          margin: 0 0 12px 0;\n        ");
        case "paragraph1":
            return "\n          color: ".concat(theme_1.default.colorsPalette.gray.default, ";\n          font-size: 18px;\n          font-weight: ").concat(theme_1.default.fontWeights.regular, ";\n          margin: 0 0 16px 0;\n          line-height: 1.45;          \n        ");
        case "paragraph2":
            return "\n          color: ".concat(theme_1.default.colorsPalette.gray.default, ";\n          font-size: 16px;\n          margin: 0;\n          line-height: 1.45;          \n        ");
        case "paragraph3":
            return "\n          color: ".concat(theme_1.default.colorsPalette.gray.default, ";\n          font-size: 14px;\n          margin: 0;\n          line-height: 1.45;          \n        ");
        default:
            return "";
    }
}, function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case "title1":
            return "\n            font-size: 40px;\n          ";
        case "title2":
        case "title3":
            return "\n            font-size: 24px;\n            margin: 0 0 16px 0;\n          ";
        case "paragraph1":
            return "\n              font-size: 16px;\n            ";
        case "paragraph2":
            return "\n              font-size: 14px;\n            ";
        default:
            return "";
    }
});
var templateObject_1;
//# sourceMappingURL=styles.js.map